import * as React from 'react';
import { FormErrors, formValueSelector, getFormSyncErrors, InjectedFormProps, reduxForm, submit } from 'redux-form';
import { cloneDeep, flow, forEach, get, head, intersection, isEmpty, mapValues, size, split } from 'lodash';
import * as Commonmark from 'react-commonmark';
import { II18nMessages } from '../../../../services/branding/models';
import { Form } from 'react-bootstrap';
import {
  GroupType,
  IChannel,
  IDestination,
  IOptionMap,
  IPolicyApplication, IPremium,
  IProduct,
  IStateCities,
  ITraveller,
  TripType
} from '../../../../data/api/models';
import { actions as quoteActions, getInitValues, setCollapsable } from '../../../../services/quote/reducer';
import { connect } from 'react-redux';
import { IStore } from '../../../../redux/IStore';
import { IAuthState } from '../../../../services/auth/models';
import BusinessContinuityPlan from '../../../../helpers/BusinessContinuityPlan';
import { InfoAnnie } from '../../components/InfoAnnie';
import { ChooseYourCover } from '../Components/ChooseYourCover';
import { AboutYou } from '../Components/AboutYou';
import { isAdult, isValidDate, validateRegex } from '../../../../util/validators';
import { QuoteStepButtons } from '../Components/QuoteStepButtons';
import { ValidationFailed } from '../Components/ValidationFailed';
import { TermsAndConditions } from '../Components/TermsAndConditions';
import { format } from 'date-fns';
import { bindActionCreators } from 'redux';
import { Collapsable, ICollapsableComponent, IQuoteActions, IQuoteState } from '../../../../services/quote/models';
import { ImportantStatements } from '../AboutTheTravellers/component/ImportantStatements';
import GroupTypeSelection from '../Components/GroupTypeSelection';
import { scrollToTop } from '../../../../helpers/TravelApplication';
import EmergencyMessaging, { EmergencyMessagingEnum } from '../../../../components/EmergencyMessaging';
import Heap from '../../../../helpers/Heap';
import { AdmiralCardV2 } from '../Components/AdmiralCardV2';
import { removeEmpty } from '../../../../helpers/Objects';

interface IStartNewQuoteProps extends InjectedFormProps {
  destinations: IDestination[];
  stateCities: IStateCities[];
  i18n: II18nMessages;
  groupType: GroupType;
  tripType: TripType;
  startDate: string;
  endDate: string;
  options: IOptionMap,
  product: IProduct;
  destinationsValue: string[];
  stateCitiesValue: string[];
  region: string;
  channel: IChannel;
  quoteState: IQuoteState;
  quote: IPolicyApplication;
  travellers: ITraveller[];
  medicalHistory: boolean;
  medicalDeclaration: any[]
  quotationDeclaration: boolean;
  isInstaquote: boolean;
  isDirectquoteRetrieval: boolean;
  maxTripDuration: any;
  initialValues: IPolicyApplication;
  collapsable: ICollapsableComponent;
  dispatch: any;
  quoteForEdit: boolean;
  premiums: IPremium[];

  change(field: string, value: any): void;

  dob: any;
  synchronousError: any;

  renderDefinition(name: string): any;

  auth: IAuthState;
  actions: {
    quote: IQuoteActions;
    submit(name: string);
  };
}

class StartNewQuote extends React.Component<IStartNewQuoteProps, any> {

  constructor(props) {
    super(props);
    const isFreshPageLoad = !props.startDate; // not by back button
    this.state = {
      disableContinue: !props.isDirectquoteRetrieval && isFreshPageLoad,
      loading: false, // Hack to Re-load the travellers array part1 (part2 in GroupTypeSelection)
    }
    Heap.handleHeapStartPage('StartNewQuote')
    scrollToTop();
    this.initValues();
  }

  private checkMedicalQuestions = () => {
    const { initialValues, change } = this.props;
    let hasSomeYesAnswer = null;
    let hasAllFalseAnswer = null;

    forEach(initialValues.medicalDeclaration, (value, key) => {
      if (get(value, 'answer')) {
        hasSomeYesAnswer = true;
      }

      if (get(value, 'answer') === false) {
        hasAllFalseAnswer = true;
      }

    })

    if (hasSomeYesAnswer) {
      change('medicalHistory', false)
    }

    if (!hasSomeYesAnswer && hasAllFalseAnswer) {
      change('medicalHistory', true)
    }
  }

  private initValues = () => {
    const {
      product,
      change,
      quotationDeclaration,
      initialValues,
      auth,
    } = this.props;

    const data = getInitValues(product);

    forEach(data, (value, key) => {
      if (initialValues[key] === null) {
        change(key, value);
      }
    });
    change('quotationTypes', 'Admiral Direct');
    change('residency', 'uk');

    if (typeof quotationDeclaration !== 'boolean') {
      change('quotationDeclaration', null);
    }

    change('calculateAllSchemes', true);

    // console.log(mapValues(cloneDeep(product?.metadata?.medical_declaration_questions),
    //   (declaration) => ({ ...declaration, answer: null }),
    // ))

    if (size(initialValues.medicalDeclaration) === 0) {
      change(
        'medicalDeclaration',
        mapValues(cloneDeep(product?.metadata?.medical_declaration_questions),
          (declaration) => ({ ...declaration, answer: null }),
        ),
      );
    }

    const dateFromApi = (date) => {
      if (!date) {
        return '';
      }

      const parsedDate = format(new Date(date), 'dd/MM/yyyy');

      return parsedDate !== 'Invalid Date' ? parsedDate : '';
    };

    if (auth.isAuthenticated) {
      const dob = split(dateFromApi(auth.customer.dob), '/');
      change('travellers[0].title', auth.customer.title);
      change('travellers[0].dob', dateFromApi(auth.customer.dob));
      change('travellers[0].firstName', auth.customer.firstName);
      change('travellers[0].lastName', auth.customer.lastName);
      change('travellers[0].email', auth.customer.email);
      change('travellers[0].phone', auth.customer.phone1);
      change('travellers[0].address.postcode', auth.customer.address.postcode);
      change('travellers[0].address.line1', auth.customer.address.line1);
      change('travellers[0].address.line2', auth.customer.address.line2);
      change('travellers[0].address.town', auth.customer.address.town);
      change('travellers[0].address.county', auth.customer.address.county);
      change('travellers[0].address.country', auth.customer.address.country);
      change('dob.day', dob[0]);
      change('dob.month', dob[1]);
      change('dob.year', dob[2]);
    }

  }

  public componentWillMount() {
    this.checkMedicalQuestions();
  }

  componentDidUpdate(prevProps: Readonly<IStartNewQuoteProps>, prevState: Readonly<any>, snapshot?: any) {
    const { tripType, change, destinationsValue, groupType } = this.props;
    if (tripType === 'single') {
      change('region', '');
      change('maxTripDuration', '');
      change('renewalStatus', null);
    }
    if (tripType === 'annual') {
      change('endDate', '');
      change('destinations', []);
      change('stateCities', []);
    }
    if (destinationsValue && destinationsValue.length && !intersection(destinationsValue, ['USA', 'United States']).length) {
      change('stateCities', ['']);
    }

    if (prevProps.groupType !== groupType) {
      this.setState({ loading: true })
      setTimeout(() => {
        this.setState({ loading: false });
      }, 0);
    }
  }

  private resetForm = () => {
    const { change } = this.props;
    change('tripType', '');
    change('startDate', '');
    change('endDate', '');
    change('destinations', []);
    change('stateCities', []);
    change('region', '');
    change('options', {});
  }

  private isRenewal() {
    const { quote } = this.props;
    return get(quote, 'application.quoteType', '') === 'renewal';
  }

  private checkIfAddressLinePostcodeIsPopulated = () => {
    const { travellers } = this.props;
    return get(travellers, `[0].address.line1`, '') !== '';
  }

  private renderTravellersDisplay = () => {
    const { travellers, groupType } = this.props;

    if (isEmpty(travellers)) {
      return null;
    }

    if (groupType === 'individual' || groupType === 'couple') {
      return (<>
        {travellers.map((traveller, index) => {
          return (
            <div className={'traveller-info-container-display'} key={index}>
              <div className={'flex--30 flex--stretch traveller-info'}>
                {traveller.title + ' ' + traveller.firstName + ' ' + traveller.lastName}
              </div>
            </div>
          );
        })}
      </>);
    } else {
      const adults = travellers.filter(t => t.type === 'adult').length;
      const children = travellers.length - adults;
      return (<>
        <div>{adults} Adults</div>
        <div>{children} Children or dependants</div>
      </>);
    }
  }

  private handleContinueTravellers = () => {
    const { dispatch } = this.props;
    this.setState({ disableContinue: false })
    dispatch(setCollapsable(Collapsable.WHO_IS_TRAVELLING, Collapsable.SCHEME_CHOICE));
  }
  private onChangeCollapse = (collapsableComponent: string) => () => {
    const { dispatch } = this.props;
    dispatch(setCollapsable(null, collapsableComponent));
  }

  public render() {
    const {
      submitting,
      handleSubmit,
      valid,
      submitFailed,
      channel,
      travellers,
      groupType,
      tripType,
      change,
      product,
      dob,
      actions,
      synchronousError,
      quotationDeclaration,
      options,
      maxTripDuration,
      i18n,
      collapsable,
      dispatch,
      renderDefinition
    } = this.props;

    const { disableContinue, loading } = this.state;

    const isMobile = window.innerWidth <= 480;

    const bcp = channel.bcp || null;
    const bcpMessage = BusinessContinuityPlan.getBCPMessage(bcp);
    const isRenewal = this.isRenewal();
    const isAnnual = tripType === 'annual';
    const leadTraveller = head(travellers);
    const day = get(leadTraveller, 'dobSeparate.day');
    const month = get(leadTraveller, 'dobSeparate.month');
    const year = get(leadTraveller, 'dobSeparate.year');
    let dobError = '';
    let disableButton = false;

    if (day && month && year) {
      dobError = synchronousError?.travellers?.[0]?.dob;
    }

    const declarationIsFalse = (typeof quotationDeclaration === 'boolean' && quotationDeclaration === false)
    disableButton = declarationIsFalse || !collapsable?.whoIsTravelling?.isEditable;

    // console.log('>> DISABLED? ', disableButton || disableContinue || !valid || synchronousError);
    return (
      <div className="steps-container start-new-quote" style={{ marginTop: '40px' }}>

        <Form horizontal={true} onSubmit={handleSubmit} autoComplete="off">
          {(bcpMessage) && (
            <div className="steps-container">
              <div className={'section-important'}>
                <div className={'important'}>
                  <Commonmark source={bcpMessage}/>
                </div>
              </div>
            </div>
          )}

          <EmergencyMessaging type={EmergencyMessagingEnum.QUOTE_JOURNEY}/>

          {submitFailed && !valid && (
            <ValidationFailed/>
          )}

          <InfoAnnie title={'Hello there!'}
                     text={"Let's begin with some details about you and the type of cover you need."}/>

          <ImportantStatements
            quotationDeclaration={quotationDeclaration}
            collapsable={collapsable}
            dispatch={dispatch}
            renderDefinition={renderDefinition}
            {...this.props}
          />

          <AboutYou
            selection={leadTraveller}
            index={0}
            isRenewal={isRenewal}
            errorDob={dobError}
            type={'adult'}
            dob={dob}
            channel={channel}
            collapsable={collapsable}
            dispatch={dispatch}
            {...this.props}
          />

          <ChooseYourCover
            product={product}
            isRenewal={isRenewal}
            change={change}
            selection={tripType}
            options={options}
            renderDefinition={renderDefinition}
            onResetForm={this.resetForm}
            synchronousError={synchronousError}
            collapsable={collapsable}
            dispatch={dispatch}
            isAnnual={isAnnual}
            maxTripDuration={maxTripDuration}
            actions={actions}
            {...this.props}
          />

          {/* Who will be travelling? */}
          {travellers && travellers.length >= 1 && (<>
            <AdmiralCardV2
              title={'Who will be travelling?'}
              icon={'people.svg'}
              collapsable={{
                value: collapsable.whoIsTravelling,
                onHandleChange: this.onChangeCollapse(Collapsable.WHO_IS_TRAVELLING)
              }}
              headerMessage={{ showAfterTouched: true, onClosed: this.renderTravellersDisplay() }}
              scrollIntoView={{ afterOpened: isMobile }}
            >
              {!loading && (
                <GroupTypeSelection
                  renderDefinition={renderDefinition}
                  recalculate={this.handleContinueTravellers}
                  forceShowRecalculate={true}
                  tripType={tripType}
                  groupType={groupType}
                  i18n={i18n}
                  product={product}
                  synchronousError={synchronousError}
                  {...this.props}
                />
              )}
            </AdmiralCardV2>
          </>)}

          <div style={{ marginBottom: '20px' }}/>

          <TermsAndConditions/>

          <QuoteStepButtons submitting={submitting}
                            submitFailed={submitFailed}
                            submitButtonType={'validateButton'}
                            synchronousError={synchronousError}
                            checkForErrors={true}
                            submit={actions.submit}
                            disable={disableButton || disableContinue || !valid || synchronousError}
                            valid={valid && this.checkIfAddressLinePostcodeIsPopulated()}/>

        </Form>
      </div>
    );
  }
}

const validateTravelers = (travelers?: any[]) => {
  if (!travelers?.length) return {};

  const errors = travelers
    .map((traveller, index) => {
      if (!traveller) return undefined;
      const dob = traveller.dobSeparate?.day && traveller.dobSeparate?.month && traveller.dobSeparate?.year ?
        `${traveller.dobSeparate?.day}/${traveller.dobSeparate?.month}/${traveller.dobSeparate?.year}` : undefined;
      return { // traveller tests
        dob: isValidDate(dob)
          || (index === 0 ? isAdult(dob) : undefined)
          || validateRegex(/\d{2}\/\d{2}\/19|20\d{2}/, 'Year has to be: 19xx or 20xx')(dob),
        title: !traveller.title ? 'Title is required' : undefined,
      }
    })
    .map(err => removeEmpty(err));

  return removeEmpty(errors) ? { travellers: errors } : {};
};

let formErrors: FormErrors<any, any> = {}; // remove this when form values has only 1 shape
const validate = (values, props) => {
  // "values" come in multiple shapes.
  // - can be an object - of all the form validation fields, where Travellers are held in: values.travellers
  // - can be an array - of Travellers
  let errors: FormErrors<any, any> = {};

  if (Array.isArray(values) && values.length) {
    // - values:array -> the travellers array arrived
    // this always happens in the 2. render cycle after the whole form "values" been passed in at the 1. cycle
    errors = formErrors;
    errors = { ...errors, ...validateTravelers(values) };
  } else {
    // - values:object -> the full form arrived
    errors = { ...errors, ...validateTravelers(values.travellers) };
    if (!values.tripType) errors.tripType = 'No trip type selected.';
  }
  formErrors = errors; // save for isArray case

  return Object.keys(errors).length ? errors : undefined;
};

let selector;

export default flow([
  reduxForm({
    form: 'quote',
    validate,
    destroyOnUnmount: false,
    forceUnregisterOnUnmount: false,
  }),
  (component) => {
    selector = formValueSelector('quote');

    return component;
  },
  connect(
    (state: IStore) => {
      const tripType = selector(state, 'tripType');
      const travellers = selector(state, 'travellers');
      const dob = selector(state, 'dob');
      const startDate = selector(state, 'startDate');
      const endDate = selector(state, 'endDate');
      const region = selector(state, 'region');
      const groupType = selector(state, 'groupType');
      const destinationsValue = selector(state, 'destinations');
      const stateCitiesValue = selector(state, 'stateCities');
      const medicalHistory = selector(state, 'medicalHistory');
      const medicalDeclaration = selector(state, 'medicalDeclaration');
      const quotationDeclaration = selector(state, 'quotationDeclaration');
      const options = selector(state, 'options');
      const maxTripDuration = selector(state, 'maxTripDuration');
      const premiums = selector(state, 'premiums');
      const synchronousError = getFormSyncErrors('quote')(state);
      return {
        auth: state.auth,
        quoteState: state.quote,
        quoteForEdit: state.quote.quoteForEdit || false,
        collapsable: state.quote.collapsableComponents,
        tripType,
        travellers,
        dob,
        startDate,
        endDate,
        region,
        groupType,
        medicalHistory,
        options,
        synchronousError: Object.keys(synchronousError).length ? synchronousError : undefined,
        destinationsValue,
        stateCitiesValue,
        medicalDeclaration,
        quotationDeclaration,
        maxTripDuration,
        premiums
      };
    },
    (dispatch) => ({
      actions: {
        dispatch,
        submit: bindActionCreators(submit, dispatch),
        quote: bindActionCreators({ ...quoteActions }, dispatch),
      },
    }),
  ),
])(StartNewQuote);
